import React from "react";
//import { useHistory } from "react-router-dom";
import cx from "classnames";

import styles from "./MarketingBlock.module.scss";
import desktopImg from "../assets/img/2608_Miffy_Ecom_CustomerPortal_Desktop.webp";
import mobileImg from "../assets/img/2608_Miffy_Ecom_CustomerPortal_Mobile.webp";
import { useSelector } from "react-redux";

const SHOW_MARKETING_BLOCK = false;

function MarketingBlock() {
    //const history = useHistory();
    const subscriptions = useSelector((s) => s.subscriptions.subscriptions);
    const subscription = subscriptions ? subscriptions.length : undefined;

    function handleClick() {
        //history.push("/subscriptions");
        window.location.href = "https://grind.co.uk/collections/grind-miffy";
    }

    if (SHOW_MARKETING_BLOCK && subscription > 0) {
        return (
            <section className={cx(styles.marketingBlock)}>
                <div className={cx(styles.content)}>
                    <h3>Don't miss the Miffy collab.</h3>
                    {/*<p>
                        Edit your subscription to try our new Honey Nut and
                        Sweet Miso coffee pods.
                    </p>*/}
                    <button onClick={handleClick}>Shop now</button>
                </div>

                <picture className={cx(styles.image)}>
                    <source
                        media="(min-width: 768px)"
                        srcSet={desktopImg}
                        width={2556}
                        height={1182}
                    />
                    <img
                        src={mobileImg}
                        alt="flavor-img"
                        width={816}
                        height={876}
                    />
                </picture>
            </section>
        );
    }
}

export default MarketingBlock;
